// TODO: QUAR-1652: drop ADS_CAPABILITY_EXPLORE once Potato's generalised ADS_CAPABILITY hook (#25114) lands.
export const ADS_CAPABILITY_EXPLORE = 'ADS_CAPABILITY_EXPLORE' as const;
export const ADS_CAPABILITY_HOMEPAGE = 'ADS_CAPABILITY_HOMEPAGE' as const;
export const ADS_RETRIEVAL_SERVICE_BOOKING_PANEL = 'ADS_RETRIEVAL_SERVICE_BOOKING_PANEL' as const;
export const ADS_RETRIEVAL_SERVICE_NAVCARD = 'ADS_RETRIEVAL_SERVICE_NAVCARD' as const;
export const ALTERNATIVE_DATES_POLL = 'ALTERNATIVE_DATES_POLL' as const;
export const ALTERNATIVE_DATES_SESSION = 'ALTERNATIVE_DATES_SESSION' as const;
export const COMBINED_PRICING = 'COMBINED_PRICING' as const;
export const CONTENT_PLATFORM_MEDIA_DISTRIBUTION = 'CONTENT_PLATFORM_MEDIA_DISTRIBUTION' as const;
export const DESTINATION_GUIDEBOOK_CONTENT = 'DESTINATION_GUIDEBOOK_CONTENT' as const;
export const DESTINATION_IMAGE = 'DESTINATION_IMAGE' as const;
export const EXPLORE_EXPERIENCES = 'EXPLORE_EXPERIENCES' as const;
export const EXPLORE_EXPERIENCES_DOLPHINS = 'EXPLORE_EXPERIENCES_DOLPHINS' as const;
export const FENRYR_PRICE_CALENDAR = 'FENRYR_PRICE_CALENDAR' as const;
export const FENRYR_PRICE_CALENDAR_MONTH = 'FENRYR_PRICE_CALENDAR_MONTH' as const;
export const FENRYR_PRICE_CALENDAR_EXPLORE = 'FENRYR_PRICE_CALENDAR_EXPLORE' as const;
export const LOYALTY_DISCOUNTS = 'LOYALTY_DISCOUNTS' as const;
export const HOTEL_UNIFIED_BFF_INDICATIVE_PRICES = 'HOTEL_UNIFIED_BFF_INDICATIVE_PRICES' as const;
export const MANGALICA_GET_PRICES_FOR_SPAN = 'MANGALICA_GET_PRICES_FOR_SPAN' as const;
export const MANGALICA_INDICATIVE_PRICES = 'MANGALICA_INDICATIVE_PRICES' as const;
export const MICHELIN_GET_HOTEL_CARHIRE_CREATE_SEARCH =
  'MICHELIN_GET_HOTEL_CARHIRE_CREATE_SEARCH' as const;
export const MICHELIN_GET_HOTEL_CARHIRE_POLLING = 'MICHELIN_GET_HOTEL_CARHIRE_POLLING' as const;
export const MICHELIN_GET_PACKAGES = 'MICHELIN_GET_PACKAGES' as const;
export const MICHELIN_GET_PACKAGES_REAL_TIME_SAVINGS =
  'MICHELIN_GET_PACKAGES_REAL_TIME_SAVINGS' as const;
export const PARTNER_METADATA = 'PARTNER_METADATA' as const;
export const PRICE_PULSE = 'PRICE_PULSE' as const;
export const PAYMENT_DISCOUNT = 'PAYMENT_DISCOUNT' as const;
export const PLACEHOLDER_SERVICE = 'PLACEHOLDER_SERVICE' as const;
export const PRICE_ALERTS_CREATE = 'PRICE_ALERTS_CREATE' as const;
export const PRICE_INSIGHTS_GET_PRICE_BANDS = 'PRICE_INSIGHTS_GET_PRICE_BANDS' as const;
export const PREMIUM_RADAR_CREATE_SESSIONS = 'PREMIUM_RADAR_CREATE_SESSIONS' as const;
export const RADAR_CREATE_SESSIONS = 'RADAR_CREATE_SESSIONS' as const;
export const RADAR_EXPLORE = 'RADAR_EXPLORE' as const;
export const RADAR_EXPLORE_AI = 'RADAR_EXPLORE_AI' as const;
export const RADAR_POLL = 'RADAR_POLL' as const;
export const RANK_EXPLAINABILITY = 'RANK_EXPLAINABILITY' as const;
export const SONAR_V3_ALPHA_CREATE_SESSION = 'SONAR_V3_ALPHA_CREATE_SESSION' as const;
export const SONAR_V3_CREATE_SESSION = 'SONAR_V3_CREATE_SESSION' as const;
export const SONAR_V3_POLL = 'SONAR_V3_POLL' as const;
export const SONAR_V3_POLL_ALPHA = 'SONAR_V3_POLL_ALPHA' as const;
export const STREVDA_SLOTS = 'STREVDA_SLOTS' as const;
export const TERRA_GET_LOCATIONS_BY_ID = 'TERRA_GET_LOCATIONS_BY_ID' as const;
export const TRAVEL_API = 'TRAVEL_API' as const;
export const AUTOSUGGEST_SEARCH = 'AUTOSUGGEST_SEARCH' as const;
export const EXPLORE_PRICING_INDICATIVE_PRICES = 'EXPLORE_PRICING_INDICATIVE_PRICES' as const;
export const EXPLORE_PRICING_MONTHLY_PRICES = 'EXPLORE_PRICING_MONTHLY_PRICES' as const;
export const ASK_SKYSCANNER_NUDGE = 'ASK_SKYSCANNER_NUDGE' as const;
export const LOCATION_TAGS_GET = 'LOCATION_TAGS_GET' as const;

export type AdsCapabilityExploreQueryType = typeof ADS_CAPABILITY_EXPLORE;
export type AdsCapabilityHomepageQueryType = typeof ADS_CAPABILITY_HOMEPAGE;
export type AdsRetrievalServiceBookingPanelQueryType = typeof ADS_RETRIEVAL_SERVICE_BOOKING_PANEL;
export type AdsRetrievalServiceNavCardQueryType = typeof ADS_RETRIEVAL_SERVICE_NAVCARD;
export type AlternativeDatesMutationType = typeof ALTERNATIVE_DATES_SESSION;
export type AlternativeDatesQueryType = typeof ALTERNATIVE_DATES_POLL;
export type ContentPlatformMediaDistributionQueryType = typeof CONTENT_PLATFORM_MEDIA_DISTRIBUTION;
export type ExploreExperiencesQueryType = typeof EXPLORE_EXPERIENCES;
export type ExploreExperiencesDolphinsQueryType = typeof EXPLORE_EXPERIENCES_DOLPHINS;
export type FenryrPriceCalendarExploreQueryType = typeof FENRYR_PRICE_CALENDAR_EXPLORE;
export type FenryrPriceCalendarQueryType = typeof FENRYR_PRICE_CALENDAR;
export type FenryrPriceCalendarMonthQueryType = typeof FENRYR_PRICE_CALENDAR_MONTH;
export type LoyaltyDiscountsQueryType = typeof LOYALTY_DISCOUNTS;
export type MangalicaGetPricesForSpanQueryType = typeof MANGALICA_GET_PRICES_FOR_SPAN;
export type MangalicaIndicativePricesQueryType = typeof MANGALICA_INDICATIVE_PRICES;
export type MichelinGetHotelCarHireSearchQueryType =
  typeof MICHELIN_GET_HOTEL_CARHIRE_CREATE_SEARCH;
export type MichelinGetHotelCarHirePollingQueryType = typeof MICHELIN_GET_HOTEL_CARHIRE_POLLING;
export type MichelinGetPackagesQueryType = typeof MICHELIN_GET_PACKAGES;
export type MichelinGetPackagesRealTimeSavingsQueryType =
  typeof MICHELIN_GET_PACKAGES_REAL_TIME_SAVINGS;
export type PartnerMetadataQueryType = typeof PARTNER_METADATA;
export type PricePulseQueryType = typeof PRICE_PULSE;
export type PaymentDiscountQueryType = typeof PAYMENT_DISCOUNT;
export type PlaceholderServiceQueryType = typeof PLACEHOLDER_SERVICE;
export type PriceAlertsCreateQueryType = typeof PRICE_ALERTS_CREATE;
export type PriceInsightsGetPriceBandsQueryType = typeof PRICE_INSIGHTS_GET_PRICE_BANDS;
export type PostcardQueryType = typeof DESTINATION_IMAGE;
export type PremiumRadarCreateSessionsQueryType = typeof PREMIUM_RADAR_CREATE_SESSIONS;
export type RadarCreateSessionsQueryType = typeof RADAR_CREATE_SESSIONS;
export type RadarPollQueryType = typeof RADAR_POLL;
export type RadarExploreQueryType = typeof RADAR_EXPLORE;
export type RadarExploreAIQueryType = typeof RADAR_EXPLORE_AI;
export type RankExplainabilityQueryType = typeof RANK_EXPLAINABILITY;
export type SonarV3AlphaCreateSessionQueryType = typeof SONAR_V3_ALPHA_CREATE_SESSION;
export type SonarV3CreateSessionQueryType = typeof SONAR_V3_CREATE_SESSION;
export type SonarV3PollAlphaQueryType = typeof SONAR_V3_POLL_ALPHA;
export type SonarV3PollQueryType = typeof SONAR_V3_POLL;
export type StrevdaSlotsQueryType = typeof STREVDA_SLOTS;
export type TerraGetLocationsByIdQueryType = typeof TERRA_GET_LOCATIONS_BY_ID;
export type TravelApiQueryType = typeof TRAVEL_API;
export type AutosuggestSearchQueryType = typeof AUTOSUGGEST_SEARCH;
export type ExplorePricingIndicativePricesQueryType = typeof EXPLORE_PRICING_INDICATIVE_PRICES;
export type ExplorePricingMonthlyPricesQueryType = typeof EXPLORE_PRICING_MONTHLY_PRICES;
export type AskSkyscannerNudgeQueryType = typeof ASK_SKYSCANNER_NUDGE;
export type LocationTagsGetQueryType = typeof LOCATION_TAGS_GET;

export type AdsRetrievalServiceQueryTypes =
  AdsRetrievalServiceBookingPanelQueryType | AdsRetrievalServiceNavCardQueryType;

export type RadarQueryTypes = RadarCreateSessionsQueryType | RadarPollQueryType;

export type MutationType =
  | AlternativeDatesMutationType
  | PriceAlertsCreateQueryType
  | PremiumRadarCreateSessionsQueryType
  | RadarCreateSessionsQueryType
  | SonarV3AlphaCreateSessionQueryType
  | SonarV3CreateSessionQueryType;

export type QueryType =
  | AdsCapabilityExploreQueryType
  | AdsCapabilityHomepageQueryType
  | AdsRetrievalServiceQueryTypes
  | AlternativeDatesQueryType
  | ExplorePricingIndicativePricesQueryType
  | ExplorePricingMonthlyPricesQueryType
  | ContentPlatformMediaDistributionQueryType
  | ExploreExperiencesQueryType
  | ExploreExperiencesDolphinsQueryType
  | FenryrPriceCalendarExploreQueryType
  | FenryrPriceCalendarMonthQueryType
  | FenryrPriceCalendarQueryType
  | LoyaltyDiscountsQueryType
  | MangalicaGetPricesForSpanQueryType
  | MangalicaIndicativePricesQueryType
  | MichelinGetHotelCarHirePollingQueryType
  | MichelinGetHotelCarHireSearchQueryType
  | MichelinGetPackagesQueryType
  | MichelinGetPackagesRealTimeSavingsQueryType
  | PartnerMetadataQueryType
  | PricePulseQueryType
  | PaymentDiscountQueryType
  | PlaceholderServiceQueryType
  | PostcardQueryType
  | PriceAlertsCreateQueryType
  | PriceInsightsGetPriceBandsQueryType
  | RadarExploreQueryType
  | RadarExploreAIQueryType
  | RadarPollQueryType
  | RankExplainabilityQueryType
  | SonarV3PollAlphaQueryType
  | SonarV3PollQueryType
  | StrevdaSlotsQueryType
  | TerraGetLocationsByIdQueryType
  | TravelApiQueryType
  | AskSkyscannerNudgeQueryType
  | AutosuggestSearchQueryType
  | LocationTagsGetQueryType;
